import ArticleTexts from "../components/common/ArticleTexts";
import {copyrightContent} from "../models";

const CopyrightPage = () => {
    return <ArticleTexts content={copyrightContent}/>;
};

export default CopyrightPage;
